import LowestRatesPropertiesContainer from '../../../../components/containers/LowestRatesPropertiesContainer';
import preloadCustomProps from '../../../utils/preloads/preloadLowestRatesProperties';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'lowest-rates-properties',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowestRatesPropertiesContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
